import { Role } from '@src/main/modules/roles/domain/role.interface';
import { RoleRepository } from '@src/main/modules/roles/domain/role.repository';
import { CreateUpdateRoleRequest } from '@src/main/modules/roles/infrastructure/dto/createUpdateUserRequest';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/roles';

export const createRoleHttpRepository = (tokenProvider: TokenProvider): RoleRepository =>
  new RoleHttpRepository(tokenProvider);

class RoleHttpRepository implements RoleRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(): Promise<Role[]> {
    const token = await this.getAuthToken();
    const response = await api.get<Role[]>(`${path}/all`, token);
    return response;
  }

  async create(role: CreateUpdateRoleRequest): Promise<Role> {
    const token = await this.getAuthToken();
    const response = await api.post<Role>(path, token, role);
    return response;
  }

  async update(id: string, role: CreateUpdateRoleRequest): Promise<Role> {
    const token = await this.getAuthToken();
    const response = await api.put<Role>(`${path}/${id}`, token, role);
    return response;
  }

  async delete(id: string): Promise<void> {
    const token = await this.getAuthToken();
    await api.delete(`${path}/${id}`, token);
  }
}
